import type { FeedbackStatus } from '@/services/feedback-api'

export const STATUS_STYLES = {
  received: 'border-brand-purple/30 bg-brand-purple/10 text-brand-purple',
  in_review: 'border-amber-500/30 bg-amber-500/10 text-amber-700 dark:text-amber-300',
  resolved: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300',
} satisfies Record<FeedbackStatus, string>

export function formatFeedbackDate(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat('tr-TR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)
}
